import React from 'react';
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import BreadcrumbOne from "../../elements/breadcrumb/BreadcrumbOne";
import {Link} from "react-router-dom";
import { FiArrowRight } from 'react-icons/fi';

import SectionTitle from "../../elements/sectionTitle/SectionTitle";
import TestimonialOne from "../../elements/testimonial/TestimonialOne";

const Scholarship = () => {
    return (
        <>
            <SEO title="Title" />
            <Layout>
                <BreadcrumbOne 
                    title="Scholarship Program"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Scholarship"
                />
                <div className="main-content">

                <div class="container mt--100 mb--100">
                <div className="row row--30 align-items-center">
                    <div className="col-md-6 col-sm-12 mb--20">
                        
                            <h2 className="title">Putting Education First</h2>
                            <p>The I-94 West Chamber of Commerce is proud to once again offer a limited number of scholarships to graduating seniors in our chamber communities..</p>
                            <br/>
                            <img className="w-100" src="../images/i94-scholarship-program.jpg" alt="About Images" />
                            <p style={{"marginTop":"20px"}}><i>Special thanks to our generous business scholarship supporters! Thank you to Henningson & Snoxxell LTD., Jurrens Associates, and Thrivent - Nick Christoff, JB Group and many more for supporting local youth secondary education!</i></p>

                           
                       </div>
                        <div class="col-md-6 col-sm-12 mb--20">
                        <h3>Eligibility</h3>
                            <p>
                                To be eligible for a scholarship, the applicant must live in or attend school in one of the following cities: Albertville, Corcoran, Dayton, Hanover, Maple Grove, Osseo, Otsego, Rogers, or St. Michael.
                                Applicants must hold a minimum GPA of 3.0 and must provide a transcript as well as three letters of recommendation from non-family members. <br/><br/>
                                Applicants must illustrate qualities of leadership, community service, and character.
                            </p>
                            <p>Additional information will be considered, including:</p>
                            <ul>
                                <li>Quality of application materials</li>
                                <li>Extracurricular activities</li>
                                <li>Leadership positions</li>
                            </ul>
                            <a href="https://forms.gle/VWynscyg3YAhjKQX7" className="btn-default btn-icon" target="_Blank">Submit Application<i className="icon"><FiArrowRight /></i></a>
                        </div>

                          {/* Start Elements Area  */}
                    <div className="rwt-testimonial-area rn-section-gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 mb--10">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = " 2025 scholarship recipients"
                                        title = "Scholarship Winners"
                                    />
                                </div>
                            </div>
                            <TestimonialOne column="col-lg-4 col-md-6 col-12 mt--30" teamStyle="card-style-default testimonial-style-one" />
                            <p style={{'textAlign':'Center'}} className="mt-5">We are inspired by their accomplishments and can’t wait to see the impact they’ll make in the years ahead. Thank you to all who contributed!</p>
                        </div>
                    </div>
                    {/* End Elements Area  */}


                    </div>
                </div>
            </div>

           
            </Layout>
        </>
    )
}
export default Scholarship;